import graphql, { getData, getResult, mapErrorsToFormFields } from 'api/graphql'

export const basicCreationResponseFields = `
  success
  email
`

export const basicAcceptResponseFields = `
  email
  subdomain
`

export const generateGetQuery = (invitationToken, responseFields) => `
  query InvitationQuery {
    invitation(invitationToken: "${invitationToken}") {
      ${responseFields}
    }
  }
`

function generateCreateMutation(responseFields) {
  return `
    mutation CreateInvitation($agentType: String!, $name: String, $email: String!) {
      createInvitation(agentType: $agentType, name: $name, email: $email) {
        ${responseFields}
      }
    }
  `
}

function generateAcceptMutation(responseFields) {
  return `
    mutation AcceptInvitation($invitationToken: String!, $name: String!, $username: String!, $password: String!) {
      acceptInvitation(invitationToken: $invitationToken, name: $name, username: $username, password: $password) {
        ${responseFields}
      }
    }
  `
}

export const createInvitation = (
  token,
  invitation,
  responseFields = basicCreationResponseFields
) => {
  const { agentType, name, email } = invitation
  return graphql(token, generateCreateMutation(responseFields), {
    agentType,
    name,
    email,
  })
    .then(getData)
    .then(getResult('createInvitation'))
    .catch(mapErrorsToFormFields)
}

export const acceptInvitation = (
  token,
  acceptInvitationInput,
  responseFields = basicAcceptResponseFields
) => {
  const { invitationToken, name, username, password } = acceptInvitationInput
  return graphql(token, generateAcceptMutation(responseFields), {
    invitationToken,
    name,
    username,
    password,
  })
    .then(getData)
    .then(getResult('acceptInvitation'))
    .catch(mapErrorsToFormFields)
}

export const getUserByInvitation = (
  token,
  invitationToken,
  responseFields = basicAcceptResponseFields
) => {
  return graphql(token, generateGetQuery(invitationToken, responseFields))
    .then(getData)
    .then(getResult('invitation'))
    .catch(mapErrorsToFormFields)
}
